<template>
  <div class="flex shrink-0 gap-0.5">
    <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md text-[#1c4848]/50 hover:bg-[#1c4848]/5 hover:text-[#1c4848] disabled:opacity-25" aria-label="Move up" :disabled="first" @click="$emit('up')"><iconify-icon icon="solar:alt-arrow-up-linear" aria-hidden="true" /></button>
    <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md text-[#1c4848]/50 hover:bg-[#1c4848]/5 hover:text-[#1c4848] disabled:opacity-25" aria-label="Move down" :disabled="last" @click="$emit('down')"><iconify-icon icon="solar:alt-arrow-down-linear" aria-hidden="true" /></button>
    <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md text-[#1c4848]/50 hover:bg-red-50 hover:text-red-700" aria-label="Remove" @click="$emit('remove')"><iconify-icon icon="solar:close-circle-linear" aria-hidden="true" /></button>
  </div>
</template>

<script setup>
defineProps({ first: Boolean, last: Boolean });
defineEmits(['up', 'down', 'remove']);
</script>
